module.exports = __webpack_public_path__ + "img/user access.d272d3ea.png";